import { render, staticRenderFns } from "./IframeFReportView.vue?vue&type=template&id=25b61935&"
import script from "./IframeFReportView.vue?vue&type=script&lang=js&"
export * from "./IframeFReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b61935')) {
      api.createRecord('25b61935', component.options)
    } else {
      api.reload('25b61935', component.options)
    }
    module.hot.accept("./IframeFReportView.vue?vue&type=template&id=25b61935&", function () {
      api.rerender('25b61935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/IframeFReportView.vue"
export default component.exports